import { AnchorButton, Classes, Intent, Navbar } from '@blueprintjs/core';
import classNames from 'classnames';
import cloneDeep from 'lodash.clonedeep';
import React from 'react';
import { useDispatch } from 'react-redux';
import { v4 as uuid } from 'uuid';

import { projectsActionCreators } from 'src/actions/projects/actionCreators';
import { TEST_IDS } from 'src/constants/testIds';
import {
  diagramSnapshotSelector,
  isDraftDiagramSelector,
} from 'src/selectors/diagramSnapshot';
import * as copy from 'src/templates/copy';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const VoiceboxFooter = () => {
  const dispatch = useDispatch();
  const { projectId } = useRouterParams();

  const diagram = useReduxSelector(diagramSnapshotSelector(projectId));
  const isDraftDiagram = useReduxSelector(isDraftDiagramSelector(projectId));

  const handleAcceptVoicebox = () => {
    if (!isDraftDiagram || !diagram) {
      return;
    }

    const updatedModel = cloneDeep(diagram.model);
    updatedModel.modelData.draftData = undefined;

    dispatch(
      projectsActionCreators.acceptedProjectDraftDiagram(projectId, {
        id: uuid(),
        model: updatedModel,
      })
    );
  };

  const handleRejectVoicebox = () => {
    if (!isDraftDiagram || !diagram) {
      return;
    }

    const updatedModel = cloneDeep(diagram.model);
    if (!updatedModel.modelData.draftData) {
      return;
    }

    updatedModel.nodeDataArray =
      updatedModel.modelData.draftData.prevNodeDataArray || [];
    updatedModel.linkDataArray =
      updatedModel.modelData.draftData.prevLinkDataArray || [];
    updatedModel.modelData = updatedModel.modelData.draftData.prevModelData;

    dispatch(
      projectsActionCreators.rejectedProjectDraftDiagram(projectId, {
        id: uuid(),
        model: updatedModel,
      })
    );
  };

  if (!isDraftDiagram) {
    return null;
  }

  return (
    <Navbar
      className="sd-voicebox-footer"
      data-testid={TEST_IDS.voicebox.footer.container}
    >
      <Navbar.Group
        className={classNames(Classes.DARK, 'sd-voicebox-footer--center')}
      >
        <div>{copy.components.voicebox.footer.help}</div>
      </Navbar.Group>
      <Navbar.Group className="sd-voicebox-footer--right">
        <div className="sd-voicebox-footer__reject">
          <AnchorButton
            data-testid={TEST_IDS.voicebox.footer.reject}
            intent={Intent.PRIMARY}
            minimal
            onClick={handleRejectVoicebox}
            outlined
            text={copy.components.voicebox.footer.reject}
          />
        </div>
        <AnchorButton
          data-testid={TEST_IDS.voicebox.footer.accept}
          intent={Intent.PRIMARY}
          onClick={handleAcceptVoicebox}
          text={copy.components.voicebox.footer.accept}
        />
      </Navbar.Group>
    </Navbar>
  );
};
